import Foreclosure from './Foreclosure';

export default Foreclosure;
